import { apiSlice } from "features/api/apiSlice";
import { transformAppointment } from "./transformAppointment";

const getAppointment = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAppointment: build.query({
      query: (id) => `/appointments/${id}`,
      transformResponse: (res) => transformAppointment(res.d),
      providesTags: (result) => {
        return result
          ? [{ type: "Appointment", id: result.id }]
          : ["Appointment"];
      },
    }),
  }),
});

export const { useGetAppointmentQuery } = getAppointment;
